/* eslint-disable @typescript-eslint/no-explicit-any */
import createContext from '../../support/helpers/createContext';

import { FormSubmission } from '../../types/shared/FormSubmission';

type EditorState = {
  register: any;
  submission: FormSubmission | null | undefined;
};

let [useEditorState, EditorStateProvider] = createContext<EditorState>();

export { useEditorState, EditorStateProvider };
